import DropdownNumberMandatory from "./InputComponents/DropdownNumberMandatoryComponent";
import React, { useState, useEffect } from "react";
import CardHeader from "./Utils/CardHeaderComponent";
import TextNoConfidential from "./InputComponents/TextNoConfidentialComponent";
import DropdownStringMandatory from "./InputComponents/DropdownStringMandatoryComponent";
import ConfirmationModal from "./Utils/ConfirmationModal";
interface EuPolicyProps {
  errors: string[];
  dropdownValues: {
    tab: string;
    inputName: string;
    listValue: string[];
  }[];
  status: number;
  data: {
    initiative: string;
    initiativeText: string;
  };
  handleOnChangeEuPolicy: (e: React.ChangeEvent<any>) => void;
  handleDeleteEuPolicy: () => void;
}

function EuPolicy({
  data,
  handleOnChangeEuPolicy,
  handleDeleteEuPolicy,
  status,
  dropdownValues,
  errors,
}: EuPolicyProps) {
  const [isHidden, setIsHidden] = useState(true);
  const toggleVisibility = () => {
    setIsHidden((prevState) => !prevState);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleDeleteClick = () => {
    setIsModalOpen(true);
  };
  const confirmDelete = () => {
    setIsModalOpen(false);
    handleDeleteEuPolicy();
  };
  const cancelDelete = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="feedstock-container">
        <CardHeader
          isHidden={isHidden}
          toggleVisibility={toggleVisibility}
          cardName="EU Policy"
          handleDelete={status == 1 ? handleDeleteClick : null}
          notValid={errors.length > 0}
        />
        {isHidden ? null : (
          <>
            <div className="error-container">
              {errors.map((error, index) => (
                <div
                  className="error-text"
                  key={index}
                  style={{ marginBottom: "10px" }}
                >
                  {error}
                </div>
              ))}
            </div>
            <div className="questions-wrapper">
            <DropdownStringMandatory
              listInputs={
                dropdownValues.filter(
                  (item) => item.inputName == "initiative"
                )[0].listValue
              }
              label={"Related initiatives"}
              inputName={"initiative"}
              value={data.initiative}
              handleOnChange={handleOnChangeEuPolicy}
              invalidValues={["-", ""]}
            />

            {data.initiative == "-" ||
            data.initiative == "" ||
            data.initiative == "N/A" ? null : (
              <>
                <TextNoConfidential
                  label={
                    "Please explain how your project contributes to the selected EU policy"
                  }
                  textValid={true}
                  textValue={data.initiativeText}
                  textName={"initiativeText"}
                  onChange={handleOnChangeEuPolicy}
                  display={false}
                  isMandatory={true}
                />
              </>
            )}
            </div>
          </>
        )}
      </div>
      <ConfirmationModal
        isOpen={isModalOpen}
        onRequestClose={cancelDelete}
        onConfirm={confirmDelete}
        title="
        Confirm deletion"
        message="Are you sure you want to delete this component ?"
      />
    </>
  );
}

export default EuPolicy;
